const esc = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
const money = (v) => (v == null ? "" : Number(v).toFixed(2));

export function buildFloorAuditCsv(data) {
  const out = [];
  const row = (...cells) => out.push(cells.map(esc).join(","));
  row(`Floor Audit ${data.start} to ${data.end} (totals ex VAT; under = negative, over = positive)`);
  row("Metric", "Quotes", "£");
  data.summary.forEach((m) => row(m.label, m.count ?? "", money(m.value)));
  row();
  row("Estimator", "Quotes", "Hours Under", "Hours Under £", "Hours Over", "Hours Over £",
    "Mark-up Under", "Mark-up Under £", "Mark-up Over", "Mark-up Over £", "Repairs Under", "Repair £",
    "Under Any Floor", "% Under", "All Under £");
  data.estimators.forEach((e) => row(e.estimator, e.quotes, e.hours_under_count, money(e.hours_under),
    e.hours_over_count, money(e.hours_over), e.markup_under_count, money(e.markup_under),
    e.markup_over_count, money(e.markup_over), e.repair_count, money(e.repair_under),
    e.any_count, `${e.any_pct}%`, money(e.all_under)));
  row();
  row("Quote No", "Version", "Created", "Estimator", "Customer", "Site", "Labour Type", "Depot", "Job Type",
    "Status", "Current Total £", "Default Mark-up %", "Hours Under", "Hours Under £", "Hours Over", "Hours Over £",
    "Mark-up Under", "Mark-up Under £", "Mark-up Over", "Mark-up Over £", "Repair Non-Travel Hours",
    "Repair Hours Short", "Repair £", "All Under £", "Total At Floors £");
  data.quotes.forEach((q) => row(q.quote_number, q.version, q.created, q.estimator, q.customer, q.site,
    q.labour_type, q.depot, q.job_type, q.status, money(q.base), q.expected_markup,
    q.hours_under_notes.join("; "), money(q.hours_under), q.hours_over_notes.join("; "), money(q.hours_over),
    q.markup_under_notes.join("; "), money(q.markup_under), q.markup_over_notes.join("; "), money(q.markup_over),
    q.repair_hours ?? "", q.repair_short ?? "", money(q.repair_under), money(q.all_under), money(q.total_at_floors)));
  return "\uFEFF" + out.join("\r\n") + "\r\n";
}

export function downloadCsv(text, filename) {
  const url = URL.createObjectURL(new Blob([text], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
